import DeviceItem from './DeivceItem';

export default DeviceItem;
